/* eslint-disable */

export const GET_REQUESTS_SUCCESS = 'GET_REQUESTS_SUCCESS'
